import { DownloadAppBannerModule } from './../common/download-app-banner/download-app-banner.module';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { CloseBtnModule } from './../common/close-btn/close-btn.module';
import { SipTopBannerModule } from './../common/sip-top-banner/sip-top-banner.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '../shared/shared.module';
import { StoryRoutingModule } from './story-routing.module';
import {
  MainComponent, StoryTabsComponent, StoryTabComponent, UpdatesTabComponent, UtmPopupComponent
} from './components';
import { MiniStoryModule } from '../common/mini-story/mini-story.module';
import { FollowCampaignModule } from '../common/follow-campaign/follow-campaign.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { StoryV3BannerModule } from '../common/story-v3-banner/story-v3-banner.module';
import { CampaignerV3Module } from '../common/campaigner-v3/campaigner-v3.module';
import { PaymentOtdModule } from '../common/payment-otd/payment-otd.module';
import { BannerModule } from '../common/banner/banner.module';
import { BenficiaryCardModule } from '../common/benficiary-card/benficiary-card.module';
import { ButtonModule } from '../common/button/button.module';
import { ContactDialogModule } from '../common/contact-dialog/contact-dialog.module';
import { DocumentModule } from '../common/document/document.module';
import { DonateNowModule } from '../common/donate-now/donate-now.module';
import { DonationMethodsModule } from '../common/donation-methods/donation-methods.module';
import { EndFundraiserBannerModule } from '../common/end-fundraiser-banner/end-fundraiser-banner.module';
import { FaqsModule } from '../common/faqs/faqs.module';
import { FbShareModule } from '../common/fb-share/fb-share.module';
import { FundraiserSIPBannerModule } from '../common/fundraiser-sipbanner/fundraiser-sipbanner.module';
import { HospitalDoctorContactModule } from '../common/hospital-doctor-contact/hospital-doctor-contact.module';
import { InnerTemplaterModule } from '../common/inner-templater/inner-templater.module';
import { KettoAssuredModule } from '../common/ketto-assured/ketto-assured.module';
import { ModuleLoaderModule } from '../common/module-loader/module-loader.module';
import { PaymentModule } from '../common/payment/payment.module';
import { PlaceholderLoaderModule } from '../common/placeholder-loader/placeholder-loader.module';
import { ReferFriendModule } from '../common/refer-friend/refer-friend.module';
import { SipPitchCardModule } from '../common/sip-pitch-card/sip-pitch-card.module';
import { SocialNumberModule } from '../common/social-number/social-number.module';
import { SocialShareBtnModule } from '../common/social-share-btn/social-share-btn.module';
import { SocialShareModule } from '../common/social-share/social-share.module';
import { SocialStripModule } from '../common/social-strip/social-strip.module';
import { StoryDocsModule } from '../common/story-docs/story-docs.module';
import { SupportCardModule } from '../common/support-card/support-card.module';
import { ThankyouBannerModule } from '../common/thankyou-banner/thankyou-banner.module';
import { ViewSupportersModule } from '../common/view-supporters/view-supporters.module';
import { WhatsappShareModule } from '../common/whatsapp-share/whatsapp-share.module';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { InViewportModule } from 'ng-in-viewport';
import { MultiPatientNoteComponent } from '../common/multi-patient-note/multi-patient-note.component';
import { ComponentLoader } from '../core/component-loader/component-loader.component';
import { ExtraProductSelectComponent } from '../core/extra-product-select/extra-product-select.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { EndedFundraiserV2Component } from '../common/ended-fundraiserV2/ended-fundraiser-v2.component';

/**Story components */
const StoryComponents = [
  MainComponent, StoryTabsComponent, StoryTabComponent, UpdatesTabComponent, UtmPopupComponent
];
/** Internal Modules */
const AppModules = [
  SharedModule, StoryRoutingModule, SupportCardModule,
  InnerTemplaterModule, ViewSupportersModule, DonationMethodsModule,
  ButtonModule, KettoAssuredModule, FbShareModule, WhatsappShareModule,
  DonateNowModule, ContactDialogModule, EndFundraiserBannerModule,
  ThankyouBannerModule, PlaceholderLoaderModule, SocialShareBtnModule, FaqsModule,
  SocialStripModule, SocialShareModule, SocialNumberModule,
  BannerModule, BenficiaryCardModule, StoryDocsModule, ReferFriendModule, ModuleLoaderModule,
  PaymentModule, DocumentModule, FundraiserSIPBannerModule, SipTopBannerModule, DownloadAppBannerModule, CloseBtnModule,
  SipPitchCardModule, HospitalDoctorContactModule
];
@NgModule({
  imports: [
    CommonModule,
    MatTabsModule,
    MatBottomSheetModule,
    MatExpansionModule,
    ...AppModules,
    MiniStoryModule,
    FollowCampaignModule,
    StoryV3BannerModule,
    CampaignerV3Module,
    PaymentOtdModule,
    MatButtonModule,
    MatRippleModule,
    MatExpansionModule,
    MatTabsModule,
    InViewportModule,
    MultiPatientNoteComponent,
    ExtraProductSelectComponent,
    ComponentLoader,
    MatIconModule,
    MatSlideToggleModule,
    EndedFundraiserV2Component
  ],
  declarations: [
    ...StoryComponents,
    UtmPopupComponent,
  ],
  exports: [
    ...StoryComponents
  ]
})
export class StoryModule { }
